<template>
  <hcm-card
    :resource="resource"
    :resourceUrl="'/detail/' + resource.type + '/' + resource.uuid"
    :externalResource="false"
    :hasSource="false"
    :hasShare="false"
  >
    <div class="content-detail">
      <video class="video-player" controls preload="metadata" @play="trackPlay">
        <source :src="resource.url" type="video/mp4" />
        <p>Browser does not support playing video</p>
      </video>
      <div class="video-caption">
        {{ resource.author }}
      </div>
      <div class="video-transcript">
        {{ resource.description }}
      </div>
    </div>
  </hcm-card>
</template>

<script>
import HCMCard from "./HCMCard.vue";
export default {
  components: { "hcm-card": HCMCard },
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  computed: {
    shareTag() {
      return "Video clip";
    },
    shareTitle() {
      return this.resource.title;
    },
    shareUrl() {
      return `${window.location.origin}/detail/VideoItem/${this.resource["uuid"]}`;
    }
  },
  methods: {
    trackPlay() {
      this.$ga.event({
        eventCategory: this.resource.title,
        eventAction: "Watch"
      });
    }
  }
};
</script>

<style scoped>
.content-detail {
  margin-top: 20px;
}

.video-player {
  width: 100%;
}

.video-caption {
  margin-top: 20px;
  font-size: 13px;
}

.video-transcript {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ccc;
}
</style>
